import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { SEGMENTS, segmentUrl } from '@/lib/segments';
import { useRealTestimonials } from '@/lib/useRealTestimonials';
import {
  OG_IMAGE, LandingHeader, LandingHero, LandingDores, LandingFeatures, LandingDepoimentos,
  LandingGarantias, LandingFaq, LandingCtaFinal, LandingLinks,
} from '@/components/landing/LandingBlocks';

export default function SegmentLandingPage({ segment }) {
  const navigate = useNavigate();
  const seg = SEGMENTS[segment];
  const url = segmentUrl(seg);
  const nome = seg.nome.toLowerCase();
  const reais = useRealTestimonials({ segmento: segment });
  const depoimentos = reais.length ? reais : seg.depoimentos;
  const logos = reais.length ? reais.map((r) => ({ nome: r.negocio, logo: r.logo })) : seg.logos;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'SoftwareApplication', name: `nfcesysPdv - ${seg.title.split('|')[0].trim()}`, applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web', url, description: seg.description, keywords: seg.keywords.join(', '),
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'BRL', description: 'Teste grátis por 30 dias' },
        aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '1250' },
      },
      { '@type': 'FAQPage', mainEntity: seg.faq.map((f) => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })) },
      { '@type': 'BreadcrumbList', itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: 'https://nfcesys.com.br/' },
        { '@type': 'ListItem', position: 2, name: `PDV para ${seg.nome}`, item: url },
      ] },
    ],
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200" data-testid={`segment-page-${segment}`}>
      <Helmet>
        <title>{seg.title}</title>
        <meta name="description" content={seg.description} />
        <meta name="keywords" content={seg.keywords.join(', ')} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seg.title} />
        <meta property="og:description" content={seg.description} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seg.title} />
        <meta name="twitter:description" content={seg.description} />
        <meta name="twitter:image" content={OG_IMAGE} />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <LandingHeader navigate={navigate} />
      <LandingHero badge={`Feito para ${nome}`} Icon={seg.icon} h1a={seg.h1a} h1b={seg.h1b} h1c="fácil, descomplicado e com o melhor custo-benefício" sub={seg.sub} navigate={navigate} />
      <LandingDores titulo={`Isso acontece no seu ${nome}?`} dores={seg.dores} />
      <LandingFeatures titulo={`Tudo que um ${nome} precisa. Nada do que não precisa.`} features={seg.features} />
      <LandingDepoimentos depoimentos={depoimentos} logos={logos} real={reais.length > 0} />
      <LandingGarantias />
      <LandingFaq faq={seg.faq} />
      <LandingCtaFinal titulo={`Coloque seu ${nome} para vender com NFC-e hoje`} navigate={navigate} />
      <LandingLinks currentSegment={segment} />
    </div>
  );
}
